// Material Tailwind v2 requires these props for TypeScript compatibility
// See: https://github.com/creativetimofficial/material-tailwind/issues/528
export const mtProps = {} as {
	placeholder: undefined;
	onPointerEnterCapture: undefined;
	onPointerLeaveCapture: undefined;
	onResize: undefined;
	onResizeCapture: undefined;
};
